.rate svg {
  --stroke-width: 64;

  stroke-width: var(--stroke-width);
  stroke: var(--rc-theme-color-text-default);
}

/* TODO: resolve this class in the form item */
:global(.ant-form-item-has-error) .rate svg {
  stroke: var(--rc-theme-color-error-default);
}
